import forYouIcon from '@/assets/nav/for-you.png';
import sportIcon from '@/assets/nav/sport.png';
import cryptoIcon from '@/assets/nav/crypto.png';
import leaguesIcon from '@/assets/nav/leagues.png';
import inviteIcon from '@/assets/nav/invite.png';
/** Apple logo → tinted PNG for Win iPhone nav（透明底） */
import appleIcon from '@/assets/nav/apple.png';

/** PC / H5 顶栏频道导航图标 */
export const NAV_CHANNEL_ICONS = {
  forYou: forYouIcon,
  sport: sportIcon,
  crypto: cryptoIcon,
  leagues: leaguesIcon,
  invite: inviteIcon,
  apple: appleIcon,
  /** @deprecated 兼容旧引用，同 apple */
  iphone: appleIcon,
};
